import script from "./Framework.vue?vue&type=script&setup=true&lang=js"
export * from "./Framework.vue?vue&type=script&setup=true&lang=js"

import "./Framework.vue?vue&type=style&index=0&id=c2d851be&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/eni-dist_longform-just-transition-persone/eni-dist_longform-just-transition-persone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2d851be"]])

export default __exports__